import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 6, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M.5 1.778 1.594.667 4 3.11 6.406.667 7.5 1.777 4 5.334.5 1.778Z" }));
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
